<footer class="footer">
    <div class="footer-content justify-content-between">
        <p class="m-b-0">Copyright © {{ currentYear }} IntraCare. All rights reserved.</p>
        <span>
            <a href="https://rpm.tupelolife.com/TupeloLife_Terms_and_Conditions.pdf" class="text-gray m-r-15">Term &amp; Conditions</a>
            <a href="https://rpm.tupelolife.com/TupeloLife_Patient_Privacy_Policy.pdf" class="text-gray">Privacy &amp; Policy</a>
        </span>
    </div>
</footer>